export default "__VITE_ASSET__56faa419__"